import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { RootState } from '../../../reducers';
import * as actionsJourney from '../../../actions/journey1';
import { Button, EButtonType, IBoxCardSizes } from '@repo/apg-ui';
import './Step4.scss';
import * as actions from '../../../actions/index';
import * as _actionsFilters from '../../../actions/filters';
import IndustriesSelect from '../../../components/IndustriesSelect';
import { useNavigate } from 'react-router';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  locales: any;
  dispatch: any;
  intl: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  actionsJourney: any;
  actionsFilters: typeof _actionsFilters;
  history: any;
  industry: any;
  industries: any;
  industriesByKey: any;
  big5Industry: any;
  big5Industries: any;
  validationMessageConfig: any;
  possibleBookingDates: any;
}

const Step4 = (props: Props) => {
  const isDisableButton = (industry: string) => {
    return !(industry !== '' && industry != '0' && industry !== null);
  };
  const navigate = useNavigate();

  const handleNext = () => {
    const {
      actionsFilters: { updateIndustryAndClearBasket },
    } = props;
    const { industry } = props.userDataEC;

    updateIndustryAndClearBasket(industry);

    if (!isDisableButton(industry)) {
      navigate('/journey1/5');
    }
  };

  return (
    <div className='step4 j1'>
      <div>
        <div className='header'>
          <h4 className='title-journey'>
            <FormattedMessage
              id='ec.journey01.step04.header'
              defaultMessage='Unter welche Inhalts-Kategorie fällt Ihre Werbung?'
            />
          </h4>

          <p className='fw-bold sub-title'>
            <FormattedMessage
              id='ec.journey01.step04.headerText'
              defaultMessage='Diese Angabe benötigen wir, damit wir Ihnen buchbare Flächen anzeigen können. Bitte wählen Sie Ihre Kategorie.'
            />
          </p>
        </div>

        <div className='d-flex mt-48'>
          <IndustriesSelect isShowIcons={false} cardSize={IBoxCardSizes.SmallCard} />
        </div>

        <div className='d-flex twoButtons mt-5'>
          <Button onClick={() => navigate({ pathname: '/journey1/3' })} buttonType={EButtonType.InvertedPillMedium}>
            <FormattedMessage id='ec.components.buttons.back' defaultMessage='Zurück' />
          </Button>

          <Button
            isDisabled={isDisableButton(props.userDataEC.industry)}
            onClick={handleNext}
            buttonType={EButtonType.PillMedium}
            className='ms-4'
          >
            <FormattedMessage id='ec.components.buttons.next' defaultMessage='Weiter' />
          </Button>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    dispatch: dispatch,
    actionsJourney: bindActionCreators(actionsJourney as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Step4)));
